/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addContainerToSortiment } from '../fn/container-sortiments/add-container-to-sortiment';
import { AddContainerToSortiment$Params } from '../fn/container-sortiments/add-container-to-sortiment';
import { ContainerSelectItemDto } from '../models/container-select-item-dto';
import { ContainerSortimentCreateResponse } from '../models/container-sortiment-create-response';
import { getContainerSelectItemsFromSortiment } from '../fn/container-sortiments/get-container-select-items-from-sortiment';
import { GetContainerSelectItemsFromSortiment$Params } from '../fn/container-sortiments/get-container-select-items-from-sortiment';
import { getContainerSortiment } from '../fn/container-sortiments/get-container-sortiment';
import { GetContainerSortiment$Params } from '../fn/container-sortiments/get-container-sortiment';
import { PageContainerSortimentPageResponse } from '../models/page-container-sortiment-page-response';


/**
 * Container sortiment resource endpoints. All operations require PRODUCT_ADMIN or EASYLOT_ADMIN.
 */
@Injectable({ providedIn: 'root' })
export class ContainerSortimentsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getContainerSortiment()` */
  static readonly GetContainerSortimentPath = '/sortiments/containers';

  /**
   * Gets containers sortiment.
   *
   * Finds and returns container sortiment of logged in merchant.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getContainerSortiment()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContainerSortiment$Response(params?: GetContainerSortiment$Params, context?: HttpContext): Observable<StrictHttpResponse<PageContainerSortimentPageResponse>> {
    const obs = getContainerSortiment(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets containers sortiment.
   *
   * Finds and returns container sortiment of logged in merchant.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getContainerSortiment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContainerSortiment(params?: GetContainerSortiment$Params, context?: HttpContext): Observable<PageContainerSortimentPageResponse> {
    const resp = this.getContainerSortiment$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PageContainerSortimentPageResponse>): PageContainerSortimentPageResponse => r.body)
    );
  }

  /** Path part for operation `addContainerToSortiment()` */
  static readonly AddContainerToSortimentPath = '/sortiments/containers';

  /**
   * Creates a new instance of container sortiment.
   *
   * Adds a new container to the merchants container sortiment if it has not been added before.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addContainerToSortiment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addContainerToSortiment$Response(params: AddContainerToSortiment$Params, context?: HttpContext): Observable<StrictHttpResponse<ContainerSortimentCreateResponse>> {
    const obs = addContainerToSortiment(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new instance of container sortiment.
   *
   * Adds a new container to the merchants container sortiment if it has not been added before.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addContainerToSortiment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addContainerToSortiment(params: AddContainerToSortiment$Params, context?: HttpContext): Observable<ContainerSortimentCreateResponse> {
    const resp = this.addContainerToSortiment$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ContainerSortimentCreateResponse>): ContainerSortimentCreateResponse => r.body)
    );
  }

  /** Path part for operation `getContainerSelectItemsFromSortiment()` */
  static readonly GetContainerSelectItemsFromSortimentPath = '/sortiments/containers/select-items';

  /**
   * Gets container dropdown select items from users sortiment.
   *
   * Finds and returns container select items from sortiment of logged in merchant.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getContainerSelectItemsFromSortiment()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContainerSelectItemsFromSortiment$Response(params: GetContainerSelectItemsFromSortiment$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContainerSelectItemDto>>> {
    const obs = getContainerSelectItemsFromSortiment(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets container dropdown select items from users sortiment.
   *
   * Finds and returns container select items from sortiment of logged in merchant.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getContainerSelectItemsFromSortiment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContainerSelectItemsFromSortiment(params: GetContainerSelectItemsFromSortiment$Params, context?: HttpContext): Observable<Array<ContainerSelectItemDto>> {
    const resp = this.getContainerSelectItemsFromSortiment$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ContainerSelectItemDto>>): Array<ContainerSelectItemDto> => r.body)
    );
  }

}
